import { Refresh2 } from "iconsax-react";

interface Props {
  label: string;
  onClick: () => void;
}

export default function FilterResetButton({ label, onClick }: Props) {
  return (
    <button
      className="px-3 h-8 flex justify-center items-center gap-2 content-base-low cursor-pointer"
      onClick={onClick}>
      <Refresh2 size={16} color="currentColor" />
      <span className="text-label-sm">{label}</span>
    </button>
  );
}
